export default __webpack_public_path__ + "static/captureLeadsGraphic-9e437ac034ad10ffdda014eb10d45355.png";